module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/tutorial1_804f08.jpg";